import { ApiProperty } from "@nestjs/swagger";

export class PoQtyGrnDtoReqDto {
    @ApiProperty()
    month: number;
    @ApiProperty()
    year: number;
    @ApiProperty()
    unitId: number;

    @ApiProperty()
    reportType: string;
}